var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.054 15.825C8.54 11.425 12.27 8 16.8 8H22a5.6 5.6 0 0 0 4.91-2.905q.269-.486.44-1.025.233.526.435 1.075c.655 1.8 1.02 3.79 1.02 5.88-.005 8.03-5.35 14.54-11.955 14.575h-.05A8.8 8.8 0 0 1 8 16.81a9.19 9.19 0 0 0-4 7.59v2.8h-.8v-2.8a9.99 9.99 0 0 1 4.855-8.575m.76.485q-.015.241-.015.49c0 4.42 3.58 8 8 8h.045C22.874 24.77 28 18.765 28 11.03c0-1.755-.265-3.425-.75-4.965A6.4 6.4 0 0 1 22 8.8h-5.2a8 8 0 0 0-7.87 6.555 9.9 9.9 0 0 1 4.27-.955h6v.8h-6c-1.59 0-3.08.4-4.385 1.11"
  })));
};
export default SvgLeaf;